import React from 'react';
import { Box } from '@mui/material';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import { ProductGroupSelectEnhancedContainer as ProductGroupSelect } from './ProductGroupSelectEnhanced/ProductGroupSelectEnhancedContainer';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { ButtonGroup } from '../../ButtonGroup';
import { State } from '../redux';

const CountThresholdFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type ComponentState = State['emConfiguration']['perTaggedItemsAccumulated'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  editMode: boolean;
  fieldDisabled: (field: Fields) => boolean;
};

const PerTaggedItemsAccumulatedConfiguration: React.FC<Props> = (props) => {
  const { countPer, countThreshold, editMode, fieldDisabled, summationMode, tags } = props;

  return (
    <Box>
      <Box my={4}>
        <ButtonGroup
          label='Summation Mode'
          name='summationMode'
          readonly={fieldDisabled('summationMode')}
          selectedValue={summationMode}
        >
          <ButtonGroup.Option value='include'>Include</ButtonGroup.Option>
          <ButtonGroup.Option value='exclude'>Exclude</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ButtonGroup
          label='Count Product By'
          name='countPer'
          readonly={fieldDisabled('countPer')}
          selectedValue={countPer}
        >
          <ButtonGroup.Option value='quantity'>Quantity</ButtonGroup.Option>
          <ButtonGroup.Option value='money_amount'>Money Amount</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <CountThresholdFormInput
          id='countThreshold'
          label='Count Threshold'
          readonly={fieldDisabled('countThreshold')}
          type='text'
          value={countThreshold}
          required={true}
        />
      </Box>

      <Box mb={4}>
        <ProductGroupSelect
          editMode={editMode}
          onChange={() => {}}
          readonly={fieldDisabled('tags')}
          selectedProductGroups={tags}
        />
      </Box>
    </Box>
  );
};

export { PerTaggedItemsAccumulatedConfiguration };
